import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight, ChevronRight, Phone } from "lucide-react";
import { CONTACT } from "../data";
import { useQuote } from "../context/QuoteContext";

export const PageHero = ({ title, subtitle, image, crumb, presetService = null }) => {
  const { openQuote } = useQuote();
  return (
    <section className="relative overflow-hidden bg-navy-deep grain pt-36 pb-20 sm:pt-44 sm:pb-28">
      <div className="absolute inset-0 z-0">
        <img src={image} alt={title} className="h-full w-full object-cover opacity-30" />
        <div className="absolute inset-0 bg-gradient-to-t from-navy-deep via-navy-deep/70 to-navy-deep/40" />
      </div>

      <div className="relative z-10 mx-auto max-w-7xl px-4 sm:px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="flex items-center gap-2 text-sm text-white/50"
        >
          <Link to="/" className="hover:text-teal transition-colors">
            Home
          </Link>
          <ChevronRight className="h-4 w-4" />
          <span className="text-white/80">{crumb}</span>
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: 0.05 }}
          className="mt-6 max-w-3xl font-display text-4xl sm:text-6xl font-bold tracking-tight text-white leading-[1.02]"
        >
          {title}
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.15 }}
          className="mt-6 max-w-xl text-lg text-white/70 leading-relaxed"
        >
          {subtitle}
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.25 }}
          className="mt-9 flex flex-col sm:flex-row items-start sm:items-center gap-4"
        >
          <button
            onClick={() => openQuote(presetService)}
            data-testid="pagehero-cta"
            className="group inline-flex items-center gap-3 rounded-full bg-teal px-7 py-4 font-semibold text-white transition-transform duration-300 hover:-translate-y-1"
          >
            Gratis offerte aanvragen
            <ArrowUpRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </button>
          <a
            href={CONTACT.phoneHref}
            className="inline-flex items-center gap-3 rounded-full border border-white/20 px-7 py-4 font-semibold text-white transition-colors duration-300 hover:bg-white/10"
          >
            <Phone className="h-5 w-5 text-sky" />
            {CONTACT.phone}
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default PageHero;
